import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './LegalPages.css';

const About = () => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>About Tmper | Temporary File & Image Upload</title>
        <meta
          name="description"
          content="Tmper is a free temporary file and image upload service. Upload, copy a shareable link, and everything auto-deletes after 1 hour."
        />
        <link rel="canonical" href="https://tmper.app/about" />
        <meta property="og:title" content="About Tmper" />
        <meta
          property="og:description"
          content="Free temporary file and image upload. Share a link that auto-deletes after 1 hour."
        />
        <meta property="og:url" content="https://tmper.app/about" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="legal-container">
        <Link className="back-button" to="/">
          ← Back to Upload
        </Link>

        <h1>About Tmper</h1>
        <p className="last-updated">Simple temporary uploads, designed for sharing.</p>

        <section>
          <h2>What It Is</h2>
          <p>
            Tmper is a temporary file and image hosting service. Upload a screenshot, photo, or any file, copy the
            generated link, and share it anywhere.
          </p>
        </section>

        <section>
          <h2>How It Works</h2>
          <ul>
            <li>Upload via file picker, drag-and-drop, or paste from clipboard</li>
            <li>Get a shareable link instantly</li>
            <li>Uploads automatically delete after 1 hour</li>
          </ul>
        </section>

        <section>
          <h2>Why Temporary</h2>
          <p>
            Temporary links reduce clutter and reduce long-term exposure of sensitive screenshots or one-off files. If you
            need long-term storage, Tmper is intentionally not that.
          </p>
        </section>

        <section>
          <h2>Popular Use Cases</h2>
          <ul>
            <li>Share screenshots for quick support or troubleshooting</li>
            <li>Send files that should not live forever in chat history</li>
            <li>Post a one-time link in a forum or ticket</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default About;

